import { useQuery } from "@tanstack/react-query";
import { getTenantPath, tenantService } from "../services/tenantService";

export function useResolvedTenant() {
  const tenantPath = getTenantPath();
  return useQuery({
    queryKey: ["tenant", "resolved", tenantPath],
    queryFn: tenantService.resolve,
    staleTime: 5 * 60 * 1000,
    retry: (failureCount, error) => {
      const status = (error as { response?: { status?: number } }).response
        ?.status;
      return status !== 404 && failureCount < 1;
    },
  });
}
